import { InjectionToken } from '@angular/core';

export const KEY_ENCRYPTION = new InjectionToken<KeyEncryption>('KEY_ENCRYPTION');
export interface KeyEncryption {
  decrypt(encryptedKey: Uint8Array, nonce: Uint8Array, password: string, salt: string): Uint8Array,
  encrypt(key: Uint8Array, password: string, salt: string): {nonce: Uint8Array, encryptedKey: Uint8Array},
  get nonceLength(): number
}
